export default (context) => {
  return {
    config: {
      pageSize: 40,
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter:{
      fields: [
        {
          name: "type",
          value: -1,
          type: "select",
          label: "main.type",
          opts: {
            style: 'float-label',
            path: '/admGroup/getTypes'
          }
        }
      ],
      buttons: [
        {
          label: "main.applyFilter",
          renderIf: (ctx) => { return Number.isInteger(ctx.state.type) },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.groupId = r.data.groupId ? { value: r.data.groupId, label: r.data.groupName } : ""
        }
        return r
      },
      fields: [
        {
          col: 6,
          name: "name",
          value: null,
          type: "text",
          label: "main.name",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "last",
          value: null,
          type: "text",
          label: "main.lastName",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "mail",
          value: null,
          type: "text",
          label: "main.email",
          rules: 'required|email',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "cel",
          value: null,
          type: "number",
          label: "main.cellPhone",
          rules: "required|max:13",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "pass",
          value: null,
          type: "password",
          label: "main.password",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "inactive",
          value: false,
          type: "switch",
          label: "main.inactive",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "face",
          value: "",
          type: "dropzone",
          label: "main.photography",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admStaff/file",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 6,
          name: "sign",
          value: "",
          type: "dropzone",
          label: "main.signature",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admStaff/sign",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 6,
          name: "notifModes",
          value: null,
          type: "text",
          label: "main.notifyVia",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "externalId",
          value: null,
          type: "text",
          label: "main.externalId",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "groupId",
          value: null,
          type: "select",
          label: "main.group",
          rules: "required",
          opts: {
            style: 'float-label',
            path: 'admGroup/get?staff=1'
          }
        },
        {
          col: 6,
          name: "validSMS",
          value: false,
          type: "switch",
          label: "WhatsApp login",
          renderIf: () => context.state.idItemSelected,
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "sendWelcome",
          value: false,
          type: "switch",
          label: "Send welcome email",
          renderIf: () => context.state.idItemSelected,
          opts: {
            style: 'float-label',
          }
        },
      ]
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.lastName",
        accessor: "last"
      },
      {
        Header: "main.cellPhone",
        accessor: "cel"
      },
      {
        Header: "main.email",
        accessor: "mail"
      }
    ]
  }
}